module.exports = __webpack_public_path__ + "logo.png?47d171860fbd3f36ea76813cfe3044d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 27
// module chunks = 0